import React, {FC, PropsWithChildren, useEffect} from 'react';
import classNames from 'classnames';
import CookieBanner from 'components/CookieBanner';
import Footer from 'components/Footer';
import Header from 'components/Header';
import {usePermissions} from 'hooks/usePermissions';

import * as styles from './styles.module.scss';

export enum PageStyle {
	ContentPage,
	LoginPage,
	MarkdownPage,
	PostPage,
	SaladPage,
	SandboxPage,
}

const getClass = (style?: PageStyle): string | null => {
	switch (style) {
	case PageStyle.ContentPage:
		return styles.contentPage;
	case PageStyle.LoginPage:
		return styles.loginPage;
	case PageStyle.MarkdownPage:
		return styles.markdownPage;
	case PageStyle.PostPage:
		return styles.postPage;
	case PageStyle.SaladPage:
		return styles.saladPage;
	case PageStyle.SandboxPage:
		return styles.sandboxPage;
	}
	return null;
};

interface WrapperProps {
	style?: PageStyle;
}

const Wrapper: FC<PropsWithChildren<WrapperProps>> = ({children, style}) => {
	const {auth, error, loading} = usePermissions('network-only');

	// Check if our auth token is still valid
	useEffect(() => {
		if (error || loading || auth.isLoggedIn) {
			return;
		} else if (auth.hasToken()) {
			auth.setToken(null);
		}
	}, [auth.isLoggedIn, error, loading]);

	return (
		<div className={classNames(styles.pageWrapper, getClass(style))}>
			<Header />
			<div className={styles.pageContent}>{children}</div>
			<Footer />
			<CookieBanner />
		</div>
	);
};

export default Wrapper;
